var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 122,
    viewBox: "0 0 31 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_120_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.33398C13 2.33398 11 4.33398 11 6.83398C11 9.33398 13 11.334 15.5 11.334C18 11.334 20 9.33398 20 6.83398C20 4.33398 18 2.33398 15.5 2.33398Z",
    fill: "#ADD144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4393 112.895C15.0251 113.48 15.9749 113.48 16.5607 112.895L26.1066 103.349C26.6924 102.763 26.6924 101.813 26.1066 101.227C25.5208 100.642 24.5711 100.642 23.9853 101.227L15.5 109.713L7.01472 101.227C6.42893 100.642 5.47918 100.642 4.8934 101.227C4.30761 101.813 4.30761 102.763 4.8934 103.349L14.4393 112.895ZM12.5 6.83398C12.5 5.16241 13.8284 3.83398 15.5 3.83398V0.833984C12.1716 0.833984 9.5 3.50556 9.5 6.83398H12.5ZM15.5 3.83398C17.1716 3.83398 18.5 5.16241 18.5 6.83398H21.5C21.5 3.50556 18.8284 0.833984 15.5 0.833984V3.83398ZM18.5 6.83398C18.5 8.50556 17.1716 9.83398 15.5 9.83398V12.834C18.8284 12.834 21.5 10.1624 21.5 6.83398H18.5ZM15.5 9.83398C13.8284 9.83398 12.5 8.50556 12.5 6.83398H9.5C9.5 10.1624 12.1716 12.834 15.5 12.834V9.83398ZM14 11.334V111.834H17V11.334H14Z",
    fill: "#ADD144"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_120_4046",
    x: 0.453125,
    y: 0.833984,
    width: 30.0938,
    height: 120.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_4046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_4046",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1f2b9907552538d9fbbf78a1890c0589.svg";
export { ForwardRef as ReactComponent };